<template>
	<div>
		<van-nav-bar title="邀请统计" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">


			<van-field v-model="content" label="额外内容:" name="content" type="textarea" placeholder="在这里输入额外内容" :rules="[{ required: false }]"
			 rows="3" show-word-limit maxlength="200" />
			
			
			<van-field name="switch_checked" label="查询开关">
				<template #input>
					<van-switch v-model="switch_checked" size="20" />
				</template>
			</van-field>
			
			<div style="margin-left: 0.16rem;">
				<p style="font-size: 10px;font-weight: bold;color: #1989fa;">查询指令：“我的邀请” “查邀请”</p>
			</div>
			
			
			
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		DatetimePicker
	} from 'vant';

	Vue.use(DatetimePicker);
	export default {
		data() {
			return {
				group_id: 0,
				switch_checked: false,
				op: 'calc',
				content: ''

			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.content = res.data.content
					this.switch_checked = res.data.switch_checked
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$dialog.alert({
							message: res.message
						})
						return
					}
					this.$toast.success('已保存')
				})
			},
			onChange(e){
				this.show_time_select = false
			},
			onCancel(){
				this.show_time_select = false
			},
			showTimeSelect(){
				this.show_time_select = true
			}
		}
	}
</script>

<style>
</style>
